import { CountryCode, FeatureToggleValue } from './types';

export const FEATURE_TOGGLE_COOKIE_NAME = 'feature-toggles';
export const FEATURE_TOGGLE_OVERRIDE_HEADER_NAME = 'x-feature-toggle-overrides';
export const FEATURE_TOGGLE_SESSION_UPDATE_API_PATH = '/api/feature-toggles/session/update';
type MutableFeatureToggleCookieData = Record<string, Partial<Record<CountryCode, boolean>>>;
type MutableFeatureToggleValue = Partial<Record<CountryCode, boolean>>;

export const cleanFeatureToggleCookieData = (
  source: unknown
): Record<string, Partial<FeatureToggleValue>> => {
  const cleanedData: MutableFeatureToggleCookieData = {};

  if (source !== null && typeof source === 'object' && !Array.isArray(source)) {
    for (const [toggleName, countryOverrides] of Object.entries(source)) {
      if (
        countryOverrides !== null &&
        typeof countryOverrides === 'object' &&
        !Array.isArray(countryOverrides)
      ) {
        const cleanedCountryOverrides: MutableFeatureToggleValue = {};

        for (const [country, value] of Object.entries(countryOverrides)) {
          if (typeof value === 'boolean') {
            cleanedCountryOverrides[country as CountryCode] = value;
          }
        }

        if (Object.keys(cleanedCountryOverrides).length > 0) {
          cleanedData[toggleName] = cleanedCountryOverrides;
        }
      }
    }
  }

  return cleanedData;
};

export const getFeatureToggleCookieToken = (cookieHeader: string | undefined): string | null => {
  let token: string | null = null;

  if (cookieHeader !== undefined) {
    for (const cookie of cookieHeader.split(';')) {
      const trimmedCookie = cookie.trim();

      if (trimmedCookie.startsWith(`${FEATURE_TOGGLE_COOKIE_NAME}=`)) {
        const parsedToken = trimmedCookie.split('=').slice(1).join('=').trim();

        token = parsedToken.length === 0 ? null : parsedToken;
        break;
      }
    }
  }

  return token;
};

export const mergeToggleValues = (
  envValues: FeatureToggleValue,
  cookieOverrides: Partial<FeatureToggleValue> | undefined
): FeatureToggleValue => {
  let mergedValues: FeatureToggleValue = envValues;

  if (cookieOverrides) {
    const countries = new Set<CountryCode>();

    for (const country of Object.keys(envValues)) {
      countries.add(country as CountryCode);
    }

    for (const country of Object.keys(cookieOverrides)) {
      countries.add(country as CountryCode);
    }

    mergedValues = {};

    for (const country of countries) {
      mergedValues = {
        ...mergedValues,
        [country]: cookieOverrides[country] ?? envValues[country] ?? false
      };
    }
  }

  return mergedValues;
};
